import { useEffect, useState } from "react";
import {
  getBIGFICRADisclosure,
  getConfAppPDF,
  getContract,
  getMMLISAddOnContract,
  getIAAddOnContract,
  getAddonStatus,
} from "../../../../api/makeAPIRequest";
import { useOktaAuth } from "@okta/okta-react";
import {
  CONTRACT_STATUS_DESC,
  CONTRACT_TYPE_DESCRIPTIONS,
} from "../../../../constants/Contract";
import { Button } from "react-blueprint-library";
import {
  isCriaOnlyContract,
  isNotNullUndefinedOrEmpty,
  isSafari,
  base64ToBlob,
  isNullUndefinedOrEmpty,
} from "../../../../common/Functions";
import { useDispatch, useSelector } from "react-redux";
import { contractPDFActions } from "../../../../store/actions";
import "./PDFFormsModal.scss";
import ModalLoader from "../../../SharedComponents/Loaders/ModalLoader";
import svgs, { svgType } from "../../../../assets/svgs";

const PDFFormsModal = ({
  contracttypedesc = "",
  contractstatusdesc = "",
  contractid = "",
  mmlis = false,
  ia = false,
  applicationStatus = "",
  isOpen = false,
  isPriorContract = false,
  handleCloseModal = () => {},
}) => {
  const { authState } = useOktaAuth();
  const dispatch = useDispatch();
  const contractPDFs = useSelector((state) => state.contractPDFs[contractid]);

  const [showLoader, setShowLoader] = useState(false);

  const oktasubid = authState.accessToken.claims.uid;
  const candidateName = authState.idToken.claims.name.split(", ");

  const hasIAApproved = contractPDFs?.addOnStatuses?.some((status) => {
    return (
      status.addontypecode.includes("IA") &&
      status.contractstatusdesc.includes("Approved")
    );
  });
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.classList.toString().includes("fade")) {
        handleCloseModal();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, handleCloseModal]);

  useEffect(() => {
    const fetchPDFs = async () => {
      setShowLoader(true);

      const showViewHistoricalConfidential =
        applicationStatus === CONTRACT_STATUS_DESC.APPROVED_BY_HOME_OFFICE ||
        applicationStatus === CONTRACT_STATUS_DESC.ACKNOWLEDGED_APPROVED ||
        applicationStatus === CONTRACT_STATUS_DESC.ACKNOWLEDGED_DECLINED ||
        applicationStatus === CONTRACT_STATUS_DESC.DECLINED_BY_HOME_OFFICE;
      const pdfs = await Promise.all([
        getContract(oktasubid, contractid),
        getBIGFICRADisclosure(oktasubid, contractid),
        mmlis
          ? getMMLISAddOnContract(oktasubid, contractid)
          : ia
            ? getIAAddOnContract(oktasubid, contractid)
            : null,
        showViewHistoricalConfidential
          ? getConfAppPDF(oktasubid, contractid)
          : null,
        getAddonStatus(oktasubid, contractid),
      ]);

      const contractPDF = pdfs[0];
      if (typeof contractPDF !== "string" && contractPDF.byteLength > 10000) {
        const newContractURL = URL.createObjectURL(
          new Blob([contractPDF], { type: "application/pdf" }),
        );
        dispatch(
          contractPDFActions.setContractPdfUrl({
            contractid,
            contracturl: newContractURL,
          }),
        );
      } else {
        dispatch(
          contractPDFActions.setContractPdfUrl({
            contractid,
            contracturl: "",
          }),
        );
      }

      const disclosurePDF = pdfs[1];
      if (
        typeof disclosurePDF !== "string" &&
        disclosurePDF.byteLength > 10000
      ) {
        const newDisclosureURL = URL.createObjectURL(
          new Blob([disclosurePDF], { type: "application/pdf" }),
        );
        dispatch(
          contractPDFActions.setDisclosurePdfUrl({
            contractid,
            disclosureUrl: newDisclosureURL,
          }),
        );
      } else {
        dispatch(
          contractPDFActions.setDisclosurePdfUrl({
            contractid,
            disclosureUrl: "",
          }),
        );
      }
      if (showViewHistoricalConfidential) {
        const historicalConfidentialPDF = pdfs[3];

        if (
          typeof historicalConfidentialPDF === "string" &&
          historicalConfidentialPDF.length > 10000
        ) {
          const blob = base64ToBlob(
            historicalConfidentialPDF,
            "application/pdf",
          );
          const newHistoricalConfURL = URL.createObjectURL(blob);
          dispatch(
            contractPDFActions.setHistoricalConfPdfUrl({
              contractid,
              historicalConfUrl: newHistoricalConfURL,
            }),
          );
        } else {
          dispatch(
            contractPDFActions.setHistoricalConfPdfUrl({
              contractid,
              historicalConfUrl: "",
            }),
          );
        }
      }
      if (mmlis) {
        const mmlisPDF = pdfs[2];
        if (typeof mmlisPDF !== "string" && mmlisPDF.byteLength > 10000) {
          const newMMLISURL = URL.createObjectURL(
            new Blob([mmlisPDF], { type: "application/pdf" }),
          );
          dispatch(
            contractPDFActions.setMMLISAddOnPdfUrl({
              contractid,
              mmlisAddOnUrl: newMMLISURL,
            }),
          );
        } else {
          dispatch(
            contractPDFActions.setMMLISAddOnPdfUrl({
              contractid,
              mmlisAddOnUrl: "",
            }),
          );
        }
      }
      const addOnStatuses = pdfs[4];
      dispatch(
        contractPDFActions.setAddOnStatuses({
          contractid,
          addOnStatuses,
        }),
      );

      if (ia) {
        const iaPDF = pdfs[2];
        if (typeof iaPDF !== "string" && iaPDF.byteLength > 10000) {
          const newIAURL = URL.createObjectURL(
            new Blob([iaPDF], { type: "application/pdf" }),
          );
          dispatch(
            contractPDFActions.setIAAddOnPdfUrl({
              contractid,
              iaAddOnUrl: newIAURL,
            }),
          );
        } else {
          dispatch(
            contractPDFActions.setIAAddOnPdfUrl({
              contractid,
              iaAddOnUrl: "",
            }),
          );
        }
      }
      setShowLoader(false);
    };
    if (isNullUndefinedOrEmpty(contractPDFs) && contractid !== "") {
      fetchPDFs();
    }
  }, [contractid, contractPDFs, dispatch, oktasubid, mmlis, ia]);

  const openContract = async () => {
    try {
      if (isNotNullUndefinedOrEmpty(contractPDFs?.contractUrl)) {
        window.open(contractPDFs?.contractUrl, "_blank");
      }
    } catch (e) {
      console.log(e);
    }
  };
  const openDisclosure = async () => {
    try {
      if (isNotNullUndefinedOrEmpty(contractPDFs?.disclosureUrl)) {
        window.open(contractPDFs?.disclosureUrl, "_blank");
      }
    } catch (e) {
      console.log(e);
    }
  };
  const openHistoricalConfidential = async () => {
    try {
      if (isNotNullUndefinedOrEmpty(contractPDFs?.historicalConfUrl)) {
        window.open(contractPDFs?.historicalConfUrl, "_blank");
      }
    } catch (e) {
      console.log(e);
    }
  };
  const openMMLISAddOnContract = async () => {
    try {
      if (isNotNullUndefinedOrEmpty(contractPDFs?.mmlisAddOnUrl)) {
        window.open(contractPDFs?.mmlisAddOnUrl, "_blank");
      }
    } catch (e) {
      console.log(e);
    }
  };
  const openIAAddOnContract = async () => {
    try {
      if (isNotNullUndefinedOrEmpty(contractPDFs?.iaAddOnUrl)) {
        window.open(contractPDFs?.iaAddOnUrl, "_blank");
      }
    } catch (e) {
      console.log(e);
    }
  };
  const openConsumerNotificationRights = () => {
    try {
      window.open(
        window.REACT_APP_CONSUMER_AND_NOTIFICATION_RIGHTS_URL,
        "_blank",
      );
    } catch (e) {
      console.log(e);
    }
  };
  const openConfidentialApp = () => {
    window.open(`/confidential?candidate=${oktasubid}&contract=${contractid}`);
  };
  const downloadAll = async () => {
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    var link = document.createElement("a");

    const dlHistoricalConfidential =
      isNotNullUndefinedOrEmpty(contractPDFs?.historicalConfUrl) &&
      (applicationStatus === CONTRACT_STATUS_DESC.APPROVED_BY_HOME_OFFICE ||
        applicationStatus === CONTRACT_STATUS_DESC.ACKNOWLEDGED_APPROVED ||
        applicationStatus === CONTRACT_STATUS_DESC.ACKNOWLEDGED_DECLINED ||
        applicationStatus === CONTRACT_STATUS_DESC.DECLINED_BY_HOME_OFFICE);

    if (
      isNotNullUndefinedOrEmpty(contractPDFs?.contractUrl) &&
      contracttypedesc !== CONTRACT_TYPE_DESCRIPTIONS.MEMBER_CORP &&
      contracttypedesc !== CONTRACT_TYPE_DESCRIPTIONS.FINANCING_ONLY &&
      !isCriaOnlyContract(contracttypedesc)
    ) {
      link.download = `${candidateName[1]}_${candidateName[0]}_${
        contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.PRELIMINARY
          ? "Application"
          : "Endorsed_Contract"
      }.pdf`;
      link.href = contractPDFs?.contractUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    //Add Delay to Safari because Safari does not allow multiple file download
    if (isSafari) {
      await delay(750);
    }

    if (
      isNotNullUndefinedOrEmpty(contractPDFs?.disclosureUrl) &&
      contracttypedesc !== CONTRACT_TYPE_DESCRIPTIONS.FINANCING_ONLY
    ) {
      link.download = `${candidateName[1]}_${candidateName[0]}_Endorsed_BIG_FICRA_Disclosure.pdf`;
      link.href = contractPDFs?.disclosureUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    //Add Delay to Safari because Safari does not allow multiple file download
    if (isSafari) {
      await delay(750);
    }

    if (
      window.REACT_APP_CONSUMER_AND_NOTIFICATION_RIGHTS_URL !== null &&
      typeof window.REACT_APP_CONSUMER_AND_NOTIFICATION_RIGHTS_URL !==
        "undefined" &&
      window.REACT_APP_CONSUMER_AND_NOTIFICATION_RIGHTS_URL !== "" &&
      contracttypedesc !== CONTRACT_TYPE_DESCRIPTIONS.FINANCING_ONLY
    ) {
      link.setAttribute("download", "");
      link.href = window.REACT_APP_CONSUMER_AND_NOTIFICATION_RIGHTS_URL;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    if (dlHistoricalConfidential) {
      //Add Delay to Safari because Safari does not allow multiple file download
      if (isSafari) {
        await delay(750);
      }

      if (isNotNullUndefinedOrEmpty(contractPDFs?.historicalConfUrl)) {
        link.download = `${candidateName[1]}_${candidateName[0]}_HISTORICAL_CONFIDENTIAL_APP.pdf`;
        link.href = contractPDFs?.historicalConfUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }

    if (mmlis) {
      //Add Delay to Safari because Safari does not allow multiple file download
      if (isSafari) {
        await delay(750);
      }

      if (isNotNullUndefinedOrEmpty(contractPDFs?.mmlisAddOnUrl)) {
        link.download = `${candidateName[1]}_${candidateName[0]}_Endorsed_MMLIS_CONTRACT.pdf`;
        link.href = contractPDFs?.mmlisAddOnUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
    if (ia) {
      //Add Delay to Safari because Safari does not allow multiple file download
      if (isSafari) {
        await delay(750);
      }

      if (isNotNullUndefinedOrEmpty(contractPDFs?.iaAddOnUrl)) {
        link.download = `${candidateName[1]}_${candidateName[0]}_Endorsed_IA_CONTRACT.pdf`;
        link.href = contractPDFs?.iaAddOnUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };

  const ContractButtonLabel =
    applicationStatus === CONTRACT_STATUS_DESC.APPROVED_BY_HOME_OFFICE ||
    applicationStatus === CONTRACT_STATUS_DESC.ACKNOWLEDGED_APPROVED ||
    applicationStatus === CONTRACT_STATUS_DESC.MMLIS_Pending
      ? "Fully Endorsed Contract"
      : contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.PRELIMINARY
        ? "Candidate Application"
        : "Candidate Endorsed Contract";

  const showViewHistoricalConfidentialBtn =
    isNotNullUndefinedOrEmpty(contractPDFs?.historicalConfUrl) &&
    (applicationStatus === CONTRACT_STATUS_DESC.APPROVED_BY_HOME_OFFICE ||
      applicationStatus === CONTRACT_STATUS_DESC.ACKNOWLEDGED_APPROVED ||
      applicationStatus === CONTRACT_STATUS_DESC.ACKNOWLEDGED_DECLINED ||
      applicationStatus === CONTRACT_STATUS_DESC.DECLINED_BY_HOME_OFFICE);

  console.log(contractPDFs);

  return (
    <div>
      <div id="formsModal"></div>
      <div>
        <div className="container">
          {showLoader ? (
            <ModalLoader></ModalLoader>
          ) : (
            <div className="row">
              <div className="col-md-12">
                <ul style={{ paddingLeft: 0, listStyleType: "none" }}>
                  {contracttypedesc !==
                    CONTRACT_TYPE_DESCRIPTIONS.MEMBER_CORP &&
                    contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.FINANCING_ONLY && (
                      <li
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: 12,
                        }}
                      >
                        <div
                          style={{
                            width: 5,
                            height: 5,
                            background: "#767676",
                            borderRadius: "9999px",
                            marginRight: 12,
                            flexShrink: 0,
                            marginLeft: -8,
                          }}
                        />
                        <div
                          className="form-button-wrapper"
                          style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "-webkit-fill-available",
                            }}
                          >
                            <span
                              style={{
                                flex: 1,
                                maxWidth: 290,
                                minWidth: 290,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                display: "inline-block",
                                verticalAlign: "middle",
                              }}
                              title={ContractButtonLabel}
                            >
                              {ContractButtonLabel}
                            </span>
                          </div>
                          {isNotNullUndefinedOrEmpty(
                            contractPDFs?.contractUrl,
                          ) && (
                            <div
                              id="EndorsedContractBtn"
                              style={{ marginLeft: 8, cursor: "pointer" }}
                              onClick={openContract}
                              role="presentation"
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <span
                                  style={{
                                    width: 20,
                                    height: 20,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginLeft: 4,
                                  }}
                                >
                                  {svgs[svgType.downloadIcon]}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </li>
                    )}
                  {contracttypedesc !==
                    CONTRACT_TYPE_DESCRIPTIONS.FINANCING_ONLY && (
                    <>
                      <li
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: 12,
                        }}
                      >
                        <div
                          style={{
                            width: 5,
                            height: 5,
                            background: "#767676",
                            borderRadius: "9999px",
                            marginRight: 12,
                            flexShrink: 0,
                            marginLeft: -8,
                          }}
                        />
                        <div
                          className="form-button-wrapper"
                          style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "-webkit-fill-available",
                            }}
                          >
                            <span
                              style={{
                                flex: 1,
                                maxWidth: 290,
                                minWidth: 290,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                display: "inline-block",
                                verticalAlign: "middle",
                              }}
                              title={"Background Disclosures"}
                            >
                              Background Disclosures
                            </span>
                          </div>
                          {isNotNullUndefinedOrEmpty(
                            contractPDFs?.disclosureUrl,
                          ) && (
                            <div
                              id="BackgroundDisclosuresBtn"
                              style={{ marginLeft: 8, cursor: "pointer" }}
                              onClick={openDisclosure}
                              role="presentation"
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <span
                                  style={{
                                    width: 20,
                                    height: 20,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginLeft: 4,
                                  }}
                                >
                                  {svgs[svgType.downloadIcon]}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </li>

                      <li
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: 12,
                        }}
                      >
                        <div
                          style={{
                            width: 5,
                            height: 5,
                            background: "#767676",
                            borderRadius: "9999px",
                            marginRight: 12,
                            flexShrink: 0,
                            marginLeft: -8,
                          }}
                        />
                        <div
                          className="form-button-wrapper"
                          style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "-webkit-fill-available",
                            }}
                          >
                            <span
                              style={{
                                flex: 1,
                                maxWidth: 290,
                                minWidth: 290,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                display: "inline-block",
                                verticalAlign: "middle",
                              }}
                              title={"Consumer Notification and Rights"}
                            >
                              Consumer Notification and Rights
                            </span>
                          </div>
                          <div
                            id="ConsumerNotificationRightsBtn"
                            style={{ marginLeft: 8, cursor: "pointer" }}
                            onClick={openConsumerNotificationRights}
                            role="presentation"
                          >
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <span
                                style={{
                                  width: 20,
                                  height: 20,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginLeft: 4,
                                }}
                              >
                                {svgs[svgType.downloadIcon]}
                              </span>
                            </div>
                          </div>
                        </div>
                      </li>
                      {mmlis && (
                        <li
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: 12,
                          }}
                        >
                          <div
                            style={{
                              width: 5,
                              height: 5,
                              background: "#767676",
                              borderRadius: "9999px",
                              marginRight: 12,
                              flexShrink: 0,
                              marginLeft: -8,
                            }}
                          />
                          <div
                            className="form-button-wrapper"
                            style={{
                              display: "flex",
                              width: "100%",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "-webkit-fill-available",
                              }}
                            >
                              <span
                                style={{
                                  flex: 1,
                                  maxWidth: 290,
                                  minWidth: 290,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  display: "inline-block",
                                  verticalAlign: "middle",
                                }}
                                title={
                                  contractstatusdesc ===
                                  CONTRACT_STATUS_DESC.ACKNOWLEDGED_APPROVED
                                    ? "MMLIS Endorsed Contract"
                                    : "MMLIS Contract"
                                }
                              >
                                {contractstatusdesc ===
                                CONTRACT_STATUS_DESC.ACKNOWLEDGED_APPROVED
                                  ? "MMLIS Endorsed Contract"
                                  : "MMLIS Contract"}
                              </span>
                            </div>
                            {isNotNullUndefinedOrEmpty(
                              contractPDFs?.mmlisAddOnUrl,
                            ) && (
                              <div
                                id="MMLISAddOnBtn"
                                style={{ marginLeft: 8, cursor: "pointer" }}
                                onClick={openMMLISAddOnContract}
                                role="presentation"
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      width: 20,
                                      height: 20,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginLeft: 4,
                                    }}
                                  >
                                    {svgs[svgType.downloadIcon]}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        </li>
                      )}
                      {ia && (
                        <li
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: 12,
                          }}
                        >
                          <div
                            style={{
                              width: 5,
                              height: 5,
                              background: "#767676",
                              borderRadius: "9999px",
                              marginRight: 12,
                              flexShrink: 0,
                              marginLeft: -8,
                            }}
                          />
                          <div
                            className="form-button-wrapper"
                            style={{
                              display: "flex",
                              width: "100%",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "-webkit-fill-available",
                              }}
                            >
                              <span
                                style={{
                                  flex: 1,
                                  maxWidth: 290,
                                  minWidth: 290,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  display: "inline-block",
                                  verticalAlign: "middle",
                                }}
                                title={
                                  hasIAApproved
                                    ? "Investment Adviser Endorsed Contract"
                                    : "Investment Adviser Contract"
                                }
                              >
                                {hasIAApproved
                                  ? "Investment Adviser Endorsed Contract"
                                  : "Investment Adviser Contract"}
                              </span>
                            </div>
                            {isNotNullUndefinedOrEmpty(
                              contractPDFs?.iaAddOnUrl,
                            ) && (
                              <div
                                id="IAAddOnBtn"
                                style={{ marginLeft: 8, cursor: "pointer" }}
                                onClick={openIAAddOnContract}
                                role="presentation"
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      width: 20,
                                      height: 20,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginLeft: 4,
                                    }}
                                  >
                                    {svgs[svgType.downloadIcon]}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        </li>
                      )}
                    </>
                  )}
                  {isPriorContract && (
                    <>
                      {showViewHistoricalConfidentialBtn && (
                        <li
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: 12,
                          }}
                        >
                          <div
                            style={{
                              width: 5,
                              height: 5,
                              background: "#767676",
                              borderRadius: "9999px",
                              marginRight: 12,
                              flexShrink: 0,
                              marginLeft: -8,
                            }}
                          />
                          <div
                            className="form-button-wrapper"
                            style={{
                              display: "flex",
                              width: "100%",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "-webkit-fill-available",
                              }}
                            >
                              <span
                                style={{
                                  flex: 1,
                                  maxWidth: 290,
                                  minWidth: 290,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  display: "inline-block",
                                  verticalAlign: "middle",
                                }}
                                title={"Historical Confidential Application"}
                              >
                                Historical Confidential Application
                              </span>
                            </div>
                            <div
                              style={{ marginLeft: 8, cursor: "pointer" }}
                              id="viewConfidentialBtn"
                              onClick={() => openHistoricalConfidential()}
                              role="presentation"
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <span
                                  style={{
                                    width: 20,
                                    height: 20,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginLeft: 4,
                                  }}
                                >
                                  {svgs[svgType.downloadIcon]}
                                </span>
                              </div>
                            </div>
                          </div>
                        </li>
                      )}
                      <li
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: 12,
                        }}
                      >
                        <div
                          style={{
                            width: 5,
                            height: 5,
                            background: "#767676",
                            borderRadius: "9999px",
                            marginRight: 12,
                            flexShrink: 0,
                            marginLeft: -8,
                          }}
                        />
                        <div
                          className="form-button-wrapper"
                          style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "-webkit-fill-available",
                            }}
                          >
                            <span
                              style={{
                                flex: 1,
                                maxWidth: 290,
                                minWidth: 290,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                display: "inline-block",
                                verticalAlign: "middle",
                              }}
                              title={"View Confidential Application"}
                            >
                              View Confidential Application
                            </span>
                          </div>
                          <div
                            style={{ marginLeft: 8, cursor: "pointer" }}
                            id="viewConfidentialBtn"
                            onClick={() => openConfidentialApp()}
                            role="presentation"
                          >
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <span
                                style={{
                                  width: 20,
                                  height: 20,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginLeft: 4,
                                }}
                              >
                                {svgs[svgType.downloadIcon]}
                              </span>
                            </div>
                          </div>
                        </div>
                      </li>
                    </>
                  )}
                  {contracttypedesc !==
                    CONTRACT_TYPE_DESCRIPTIONS.FINANCING_ONLY && (
                    <div>
                      <Button
                        variant="inline"
                        onClick={downloadAll}
                        style={{ display: "flex" }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <span
                            style={{
                              width: 20,
                              height: 20,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginLeft: -12,
                              marginRight: 5,
                            }}
                          >
                            {svgs[svgType.downloadIcon]}
                          </span>
                        </div>
                        <span>Download All</span>
                      </Button>
                    </div>
                  )}
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PDFFormsModal;
